import { Component, OnInit, OnDestroy } from '@angular/core';
import {AppDataService} from "../../../services/app-data.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import { TranslationService } from '../../../services/translation.service';
import { BaseActionComponent } from './baseAction';


declare let $: any;
declare let Swal:any;

@Component({
    selector : 'cloth-action',
    templateUrl:'clothAction.html'
})
export class ClothActionComponent extends BaseActionComponent{

  public itens;
  public linkForm: FormGroup;
  public level=1;
  public option='chest';
  public slots=[
    {name:'Cabeça',kind:'head'},
    {name:'Peito',kind:'chest'},
    {name:'Pernas',kind:'legs'},
    {name:'Pés',kind:'feet'}
  ];
  public constructor(public translate: TranslationService,public _appData : AppDataService,public fb : FormBuilder, public _companyService : CompanyService) {
    super(translate,_appData,fb,_companyService)
    this.linkForm = this.fb.group({
      xEnd:0,
      yEnd:0,
      zEnd:0,
      rxEnd:0,
      ryEnd:0,
      rzEnd:0,
      sxEnd:0,
      syEnd:0,
      szEnd:0,
      distance:2
    });

  }
  public setMinAxis(){
    let action=this.currentAction();
    if (action.param.minRot){
      delete action.param.minRot
      return;
    }
    let varr
    if (action.param.staticRotate=='X'){
      varr=this._appData.object.rotation.x
    }
    if (action.param.staticRotate=='Y'){
      varr=this._appData.object.rotation.y
    }
    if (action.param.staticRotate=='Z'){
      varr=this._appData.object.rotation.z
    }
      action.param.minRot=varr;
  }

  public setMaxAxis(){
    let action=this.currentAction();
    if (action.param.maxRot){
      delete action.param.maxRot
      return;
    }
    let varr
    if (action.param.staticRotate=='X'){
      varr=this._appData.object.rotation.x
    }
    if (action.param.staticRotate=='Y'){
      varr=this._appData.object.rotation.y
    }
    if (action.param.staticRotate=='Z'){
      varr=this._appData.object.rotation.z
    }
      action.param.maxRot=varr;
  }
  public currentAction(){
    let action = this.level==1 ? this._appData.action : this._appData.secondAction;
    if (!action){
      action={kind:'cloth',param:{}}
      if (this.level==1){
        this._appData.action=action;
      }
      else{
        this._appData.secondAction=action;
      }
    }
    if (!action.param){
      action.param={end:{},itens:[]};
    }
    return action;
  }
  public selectItem(it) {
    for (let i = 0; i < this.itens.length; i++) {
      if (this.itens[i].objectId == it.objectId) {
        this.itens[i].selected= this.itens[i].selected ? false : true 
      }
    }
  }  
  public selectSlot(kind){
    this.option=kind;
    this.currentAction().param.where=kind;
  }
  public setAxis(varr){
    let action=this.currentAction();
    if (varr){
      action.param.staticRotate=varr;
    }
    else{
      delete action.param.staticRotate
    }
  }
  public processData(action){
    if (!action){
      action={kind:'cloth',param:{}}
    }
    if (!action.param){
      action.param={end:{},itens:[]};
    }
    action.param.end = this.linkForm['_value'];
    action.param.where = this.option;
    let itemArray=[]
    
    this.itens.forEach(it=>{
      if (it.selected){
        itemArray.push(it.objectId)
      }
    })
    action.param.itens=itemArray    
  }
  //Ponha a roupa na posicao final (vestida no avatar) e clique: guarda posicao/orientacao/escala finais
  public whereIAm(option){
    let linkParam = this.linkForm['_value'];

      linkParam.xEnd=this._appData.object.position.x
      linkParam.yEnd=this._appData.object.position.y
      linkParam.zEnd=this._appData.object.position.z
      linkParam.rxEnd=this._appData.object.rotation.x
      linkParam.ryEnd=this._appData.object.rotation.y
      linkParam.rzEnd=this._appData.object.rotation.z
      linkParam.sxEnd=this._appData.object.scale.x
      linkParam.syEnd=this._appData.object.scale.y
      linkParam.szEnd=this._appData.object.scale.z

    this.linkForm = this.fb.group(linkParam);
  }
  //A roupa nao se desloca: a posicao final e a mesma de quando ela foi vestida
  public removeEnd(){
    let linkParam = this.linkForm['_value'];

      linkParam.xEnd=this._appData.object.position.x
      linkParam.yEnd=this._appData.object.position.y
      linkParam.zEnd=this._appData.object.position.z
      linkParam.rxEnd=this._appData.object.rotation.x
      linkParam.ryEnd=this._appData.object.rotation.y
      linkParam.rzEnd=this._appData.object.rotation.z
      linkParam.sxEnd=this._appData.object.scale.x
      linkParam.syEnd=this._appData.object.scale.y
      linkParam.szEnd=this._appData.object.scale.z

    this.linkForm = this.fb.group(linkParam);
  }
  public childrenReloadData(){
    let action = this.currentAction();
    if (action.param.end) {
      this.linkForm = this.fb.group(action.param.end);
    }
    if (action.param.where){
      this.option=action.param.where;
    }
    this.itens=[]
    if (!this.roomProcessing){
      this._companyService.getUserRoomItemRef(this._appData.room.id).get().then(its=>{
        its.forEach(it=>{
          let item=it.data();
          item.selected=false;
          if (action.param.itens){
            action.param.itens.forEach(sit=>{
              if (sit==item.objectId){
                item.selected=true;
              }
            })
          }
          this.itens.push(item)
        })
        this.roomProcessing=false;
      })  
    this.roomProcessing=true;

    }  
  }
  public roomProcessing=false;
    public ngOnInit(): any {
    }


}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/actions/clothAction.ts